<button (click)="openQuickPanel.emit()" class="button" style="display: flex;" mat-button>
  <mat-icon>format_align_right</mat-icon>
</button>
